// @flow

import * as React from 'react';

import styles from './ViinitieBanner.module.scss';

import Xmas from 'search/components/searchResults/viinitieBanner/XmassBanner';
import Corporate from 'search/components/searchResults/viinitieBanner/CorporateBanner';
import Wedding from 'search/components/searchResults/viinitieBanner/WeddingBanner';

import { trackClickedBanner } from 'search/analytics';

const WEDDING = '33';
const MEETING = '41';
const EXHIBITION = '46';
const XMAS_PARTY = '60';

const CORPORATE_EVENT_TYPES = [MEETING, EXHIBITION];

type Props = {| eventType: string |};

export default function ViinitieBanner(props: Props): React.Node {
  if (CORPORATE_EVENT_TYPES.includes(props.eventType)) {
    return (
      <Corporate
        onClick={() => trackClickedBanner('Viinitie – Yritystilaisuudet')}
      />
    );
  } else if (props.eventType === XMAS_PARTY) {
    return (
      <Xmas onClick={() => trackClickedBanner('Viinitie – Pikkujoulut')} />
    );
  } else if (props.eventType === WEDDING) {
    return <Wedding onClick={() => trackClickedBanner('Viinitie – Häät')} />;
  } else {
    return null;
  }
}

export type BannerWrapperProps = {|
  linkUrl: string,
  onClick?: () => void,
  children: React.Node
|};

export function BannerWrapper(props: BannerWrapperProps): React.Node {
  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <a
          href={props.linkUrl}
          target="_blank"
          rel="noopener noreferrer external"
          onClick={props.onClick}
        >
          <div className={styles.adDisclaimer}>MAINOS</div>
          {props.children}
        </a>
      </div>
    </div>
  );
}
